<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div>
    <nav class="bar bar-nav">
      <router-link class="button button-link button-nav pull-left" :to="{ name: 'home'}">
        <span class="icon icon-left"></span>
        返回首页
      </router-link>
    </nav>
    <div class="content">
      <div>
        <label class="typo__label">Single select</label>
        <multiselect v-model="value" :options="options" :searchable="false" :close-on-select="false" :show-labels="false" placeholder="Pick a value"></multiselect>
        <pre class="language-json"><code>{{ value  }}</code></pre>
      </div>
    </div>
</div>
</template>
<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  import Multiselect from 'vue-multiselect'

  export default {
    mounted () {
      $.init()
//      console.log('mounted')
    },
    created () {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
      this.products = this.cartList.cartContent
    },
    data () {
      return {
        products: [],
        isCheckedAll: false,
        result: 0,
        confirmDelete: false,
        readyToDelIndex: -1,
        value: '',
        options: ['Select option', 'options', 'selected', 'mulitple', 'label', 'searchable', 'clearOnSelect', 'hideSelected', 'maxHeight', 'allowEmpty', 'showLabels', 'onChange', 'touched']
      }
    },
    methods: {
      ...mapMutations([
        'REMOVE_FROM_CART_LIST'
      ]),
      getChecked (item) {
        if (item.isChecked === void 0) {
          this.$set(item, 'isChecked', true)
        } else {
          item.isChecked = !item.isChecked
        }
//        this.isSelectedAll()
        console.log(item)
      },
      changeQuantity (good, val) {
        if (good.productQuantity === void 0) {
          this.$set(good, 'productQuantity', 1)
        }
        if (good.productQuantity === 1 && val === -1) {
          this.confirmDelete = true
//          this.readyToDelIndex = _index
        } else {
          good.productQuantity += val
        }
      },
      checkedAll () {
        if (this.isCheckedAll === false) {
          this.isCheckedAll = true
          this.products.forEach(item => {
            if (item.isChecked === void 0) {
              this.$set(item, 'isChecked', true)
            } else {
              item.isChecked = true
            }
            console.log(item.isChecked)
          })
        } else {
          this.isCheckedAll = false
          this.products.forEach(item => {
            item.isChecked = false
            console.log(item.isChecked)
          })
        }
      },
      isSelectedAll () {
        var flag = true
        this.products.forEach(item => {
          if (!item.isChecked) {
            flag = false
          }
          if (!flag) {
            this.isCheckedAll = false
          } else {
            this.isCheckedAll = true
          }
        })
      },
      removeProduct (item, index) {
        var _this = this
        console.log('index  ' + index)
        $.confirm('您确定删除此商品吗？',
        function () {
          console.log('ok')
          $.showIndicator()
          setTimeout(function () {
            $.hideIndicator()
          }, 300)
//          _this.products.splice(index, 1)
          _this.REMOVE_FROM_CART_LIST(item, index)
        },
        function () {
          console.log('cancel')
        })
      }
    },
    computed: {
      ...mapState([
        'cartList'
      ]),
      totalPrice () {
        var t = 0
        this.products.forEach(item => {
          if (item.isChecked) {
            t += item.price * item.productQuantity
          }
        })
        return t
      }
    },
    filters: {
      currencyStyle (val) {
        return ' ¥ ' + val
      }
    },
    components: {
      Multiselect
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .gotopay{
    position: absolute;
    right: 0;
    background-color: #F6383A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -39px;
    width: 100px;
    height: 54px;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
  }
  .gotopay_acitvity{
    background-color: grey;
  }
  .next-btn-wrap {
    padding: 62px 0;
    border-top: 1px solid #e9e9e9;
    text-align: center; }
  .next-btn-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 101; }
  .next-btn-wrap {
    display: block;
    width: 100%; }
  .next-btn-wrap {
    float: right; }
  .next-btn-wrap {
    padding: 0;
    border: none; }
  .check-step {
    padding: 5px 0; }
  .check-step ul {
    display: -ms-flexbox;
    display: flex;
    margin: 25px 0 50px 0; }
  .check-step ul:after {
    visibility: hidden;
    display: block;
    content: " ";
    clear: both; }
  .check-step li {
    position: relative;
    float: left;
    -ms-flex: 1;
    flex: 1;
    width: 25%;
    line-height: 1.5em;
    padding: 0 1em 1em 1em;
    border-bottom: 2px solid #ccc;
    color: #999;
    font-size: 16px;
    text-align: center; }
  .check-step li:after {
    position: absolute;
    bottom: -7px;
    left: 50%;
    margin-left: -7px;
    content: "";
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ccc; }
  .check-step li.cur {
    border-color: #EE7A23;
    color: #EE7A23; }
  .check-step li.cur:after {
    background: #EE7A23; }
 li{
   list-style-type:none
}
  @media only screen and (max-width: 767px) {
    .check-step ul {
      margin: 10px 0 25px 0; }
    .check-step li {
      font-size: 12px
    } }
  fieldset[disabled] .multiselect {
    pointer-events: none
  }

  .multiselect__spinner {
    position: absolute;
    right: 1px;
    top: 1px;
    width: 48px;
    height: 35px;
    background: #fff;
    display: block
  }

  .multiselect__spinner:after, .multiselect__spinner:before {
    position: absolute;
    content: "";
    top: 50%;
    left: 50%;
    margin: -8px 0 0 -8px;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    border-color: #41b883 transparent transparent;
    border-style: solid;
    border-width: 2px;
    box-shadow: 0 0 0 1px transparent
  }

  .multiselect__spinner:before {
    animation: a 2.4s cubic-bezier(.41, .26, .2, .62);
    animation-iteration-count: infinite
  }

  .multiselect__spinner:after {
    animation: a 2.4s cubic-bezier(.51, .09, .21, .8);
    animation-iteration-count: infinite
  }

  .multiselect__loading-enter-active, .multiselect__loading-leave-active {
    transition: opacity .4s ease-in-out;
    opacity: 1
  }

  .multiselect__loading-enter, .multiselect__loading-leave-active {
    opacity: 0
  }

  .multiselect, .multiselect__input, .multiselect__single {
    font-family: inherit;
    font-size: 14px;
    -ms-touch-action: manipulation;
    touch-action: manipulation
  }

  .multiselect {
    box-sizing: content-box;
    display: block;
    position: relative;
    width: 100%;
    min-height: 40px;
    text-align: left;
    color: #35495e
  }

  .multiselect * {
    box-sizing: border-box
  }

  .multiselect:focus {
    outline: none
  }

  .multiselect--disabled {
    opacity: .6
  }

  .multiselect--active {
    z-index: 1
  }

  .multiselect--active:not(.multiselect--above) .multiselect__current, .multiselect--active:not(.multiselect--above) .multiselect__input, .multiselect--active:not(.multiselect--above) .multiselect__tags {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
  }

  .multiselect--active .multiselect__select {
    transform: rotate(180deg)
  }

  .multiselect--above.multiselect--active .multiselect__current, .multiselect--above.multiselect--active .multiselect__input, .multiselect--above.multiselect--active .multiselect__tags {
    border-top-left-radius: 0;
    border-top-right-radius: 0
  }

  .multiselect__input, .multiselect__single {
    position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 20px;
    border: none;
    border-radius: 5px;
    background: #fff;
    padding: 0 0 0 5px;
    width: 100%;
    transition: border .1s ease;
    box-sizing: border-box;
    margin-bottom: 8px;
    vertical-align: top
  }

  .multiselect__tag ~ .multiselect__input, .multiselect__tag ~ .multiselect__single {
    width: auto
  }

  .multiselect__input:hover, .multiselect__single:hover {
    border-color: #cfcfcf
  }

  .multiselect__input:focus, .multiselect__single:focus {
    border-color: #a8a8a8;
    outline: none
  }

  .multiselect__single {
    padding-left: 6px;
    margin-bottom: 8px
  }

  .multiselect__tags-wrap {
    display: inline
  }

  .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    /*border-radius: 5px;*/
    /*border: 1px solid #e8e8e8;*/
    background: #fff
  }

  .multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #41b883;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis
  }

  .multiselect__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: normal;
    width: 22px;
    text-align: center;
    line-height: 22px;
    transition: all .2s ease;
    border-radius: 5px
  }

  .multiselect__tag-icon:after {
    content: "\D7";
    color: #266d4d;
    font-size: 14px
  }

  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #369a6e
  }

  .multiselect__tag-icon:focus:after, .multiselect__tag-icon:hover:after {
    color: #fff
  }

  .multiselect__current {
    min-height: 40px;
    overflow: hidden;
    padding: 8px 12px 0;
    padding-right: 30px;
    white-space: nowrap;
    border-radius: 5px;
    border: 1px solid #e8e8e8
  }

  .multiselect__current, .multiselect__select {
    line-height: 16px;
    box-sizing: border-box;
    display: block;
    margin: 0;
    text-decoration: none;
    cursor: pointer
  }

  .multiselect__select {
    position: absolute;
    width: 40px;
    height: 38px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;
    transition: transform .2s ease
  }

  .multiselect__select:before {
    position: relative;
    right: 0;
    top: 65%;
    color: #999;
    margin-top: 4px;
    border-style: solid;
    border-width: 5px 5px 0;
    border-color: #999 transparent transparent;
    content: ""
  }

  .multiselect__placeholder {
    color: #adadad;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px
  }

  .multiselect--active .multiselect__placeholder {
    display: none
  }

  .multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #fff;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1;
    -webkit-overflow-scrolling: touch
  }

  .multiselect__content {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
    min-width: 100%;
    vertical-align: top
  }

  .multiselect--above .multiselect__content-wrapper {
    bottom: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: none;
    border-top: 1px solid #e8e8e8
  }

  .multiselect__content::webkit-scrollbar {
    display: none
  }

  .multiselect__element {
    display: block
  }

  .multiselect__option {
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap
  }

  .multiselect__option:after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 40px;
    padding-right: 12px;
    padding-left: 20px
  }

  .multiselect__option--highlight {
    /*background: #41b883;*/
    /*outline: none;*/
    /*color: #fff*/
  }

  .multiselect__option--highlight:after {
    content: attr(data-select);
    background: #41b883;
    color: #fff
  }

  .multiselect__option--selected {
    background: #f3f3f3;
    color: #35495e;
    font-weight: 700
  }

  .multiselect__option--selected:after {
    content: attr(data-selected);
    color: silver
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff
  }

  .multiselect__option--selected.multiselect__option--highlight:after {
    background: #ff6a6a;
    content: attr(data-deselect);
    color: #fff
  }

  .multiselect--disabled {
    background: #ededed;
    pointer-events: none
  }

  .multiselect--disabled .multiselect__current, .multiselect--disabled .multiselect__select, .multiselect__option--disabled {
    background: #ededed;
    color: #a6a6a6
  }

  .multiselect__option--disabled {
    cursor: text;
    pointer-events: none
  }

  .multiselect__option--disabled.multiselect__option--highlight {
    background: #dedede !important
  }

  .multiselect-enter-active, .multiselect-leave-active {
    transition: all .15s ease
  }

  .multiselect-enter, .multiselect-leave-active {
    opacity: 0
  }

  .multiselect__strong {
    margin-bottom: 8px;
    line-height: 20px;
    display: inline-block;
    vertical-align: top
  }

  [dir=rtl] .multiselect {
    text-align: right
  }

  [dir=rtl] .multiselect__select {
    right: auto;
    left: 1px
  }

  [dir=rtl] .multiselect__tags {
    padding: 8px 8px 0 40px
  }

  [dir=rtl] .multiselect__content {
    text-align: right
  }

  [dir=rtl] .multiselect__option:after {
    right: auto;
    left: 0
  }

  [dir=rtl] .multiselect__clear {
    right: auto;
    left: 12px
  }

  [dir=rtl] .multiselect__spinner {
    right: auto;
    left: 1px
  }

  @keyframes a {
    0% {
      transform: rotate(0)
    }
    to {
      transform: rotate(2turn)
    }
  }

</style>



// WEBPACK FOOTER //
// DiyGoods.vue?fcf409f6